import InstagramChatView from './components/instagramChatView.component';

export default function InstagramChatPage() {
  return <InstagramChatView />;
}

